import { render, staticRenderFns } from "./RevenueManagerUnitCopySetupForm.vue?vue&type=template&id=1b9d07cc&scoped=true&"
import script from "./RevenueManagerUnitCopySetupForm.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerUnitCopySetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d07cc",
  null
  
)

export default component.exports